
export default function Footer() {
  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              XINRUNMODA
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              The gateway for European fashion to the global market. Connecting European brands with Chinese retailers through professional B2B supply chain services.
            </p>
            <div className="flex space-x-4">
              <a href="mailto:kim@xinrunmoda.com?cc=Vic@xinrunmoda.com,Eric@xinrunmoda.com" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </a>
              <a href="tel:+8619850822997" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-phone-line text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Services</a></li>
              <li><a href="#brands" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Brands</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Contact Info</h4>
            <div className="space-y-2 text-gray-300">
              <p className="text-sm">Hong Kong Office</p>
              <p className="text-sm">Unit 89, 3/F., Yau Lee Centre</p>
              <p className="text-sm">No.45, Hoi Yuen Road</p>
              <p className="text-sm">Kwun Tong, Hong Kong</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 XINRUNMODA. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
